<template>
  <div class="scroll-about diagonal-box" id="kerdoiv" v-animate-in>
    <div class="scroll-about-container px-3">
      <div class="scroll-about-content" id="form">
        <!-- <h2 class="mb-8" v-if="!onForm">
          Segítség kell igényeid megformálásához?
        </h2>
        <ContactForm
          v-if="!onForm"
          v-model="personal"
          class="hero-form"
          title="Fill out our form"
          name="true"
          email="true"
          path="/kerdoiv/start"
          id="hero"
        >
          <template #title>
            <h1 class="h3">Töltsd ki a kérdőívünket</h1>
          </template>
          <template #description> </template>
        </ContactForm> -->

        <div class="layer-containers mb-10">
          <div class="layer-content">
            <router-view v-slot="{ Component }">
              <component :is="Component" />
            </router-view>
          </div>
        </div>

        <svg
          class="scroll-ico"
          width="17"
          height="36"
          viewBox="0 0 17 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.79935 7.80167V19.4876C1.79935 23.0803 4.7076 25.9894 8.29668 25.9894C11.8853 25.9894 14.794 23.0789 14.794 19.4876V7.80167C14.794 4.209 11.8858 1.29981 8.29668 1.29981C4.70807 1.29981 1.79935 4.21039 1.79935 7.80167ZM0.5 7.80167C0.5 3.4929 3.98976 0 8.29668 0C12.6027 0 16.0934 3.49116 16.0934 7.80167V19.4876C16.0934 23.7964 12.6036 27.2893 8.29668 27.2893C3.99069 27.2893 0.5 23.7981 0.5 19.4876V7.80167Z"
            fill="#525252"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.64648 4.54824V7.14694C7.64648 7.50589 7.93745 7.79685 8.2964 7.79685C8.65536 7.79685 8.94632 7.50589 8.94632 7.14694V4.54824C8.94632 4.18928 8.65536 3.89832 8.2964 3.89832C7.93745 3.89832 7.64648 4.18928 7.64648 4.54824Z"
            fill="#currentColor"
            class="scroller"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.29543 34.4316L11.8691 30.8584C12.1224 30.6046 12.534 30.6046 12.7878 30.8584C13.0416 31.1118 13.0416 31.5233 12.7878 31.7771L8.755 35.8099C8.62809 35.9368 8.46177 36.0002 8.29544 36.0002C8.12911 36.0002 7.96278 35.9367 7.83589 35.8099L3.77238 31.7463C3.51858 31.4925 3.51858 31.081 3.77238 30.8272C4.02618 30.5739 4.43726 30.5739 4.69106 30.8272L8.29543 34.4316Z"
            fill="#525252"
            class="arrow"
          />
        </svg>
        <strong>Ismerj meg minket!</strong>
      </div>
    </div>
  </div>
</template>

<script>
import ContactForm from "@/components/ContactForm.vue";
import Survey from "@/views/Survey.vue";
import Summary from "@/views/Summary.vue";

export default {
  name: "ScrollAbout",
  components: {
    ContactForm,
    Survey,
    Summary
  },
  data() {
    return {
      personal: this.$store.getters.getPersonal,
      onForm: false
    };
  },
  updated() {},
  methods: {
    setPersonal(value) {
      this.$store.commit("setPersonal", value);
    }
  },
  watch: {
    $route(curr) {
      if (curr.path.includes("kerdoiv")) {
        this.onForm = true;
      } else {
        this.onForm = false;
      }
    }
  },
  mounted() {
    if (this.$route.path.includes("kerdoiv")) {
      this.onForm = true;
    }
  }
};
</script>

<style lang="scss">
.scroll-about {
  pointer-events: none;
  width: 100%;
  top: 50%;
  margin: 0 0 52px 0;
  display: block;
  position: relative;

  &-container {
    pointer-events: auto;
    padding-top: 52px;
    background: $lightgray;
  }
  &-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: 30px;
    svg {
      //width: 100%;
      display: block;
      &.scroll-ico {
        margin-bottom: 8px;
        //animation-name: pulsate;
        animation-duration: 0.8s;
        animation-direction: alternate;
        animation-iteration-count: infinite;
        .scroller {
          animation-name: changecolor;
          animation-duration: 0.8s;
          animation-direction: alternate;
          animation-iteration-count: infinite;
        }
        .arrow {
          animation-name: movearrow;
          animation-delay: 0.3s;
          animation-duration: 1s;
          animation-direction: alternate;
          animation-iteration-count: infinite;
        }
      }
    }
    strong {
      font-family: $main;
      font-size: 18px;
      line-height: 18px;
      font-weight: 500;
    }
  }
  @media screen and (min-width: $breakpoint) {
  }

  @keyframes pulsate {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-100%);
    }
  }
  @keyframes movearrow {
    0% {
      transform: translateY(1%);
    }
    100% {
      transform: translateY(-8%);
    }
  }
  @keyframes changecolor {
    0% {
      fill: rgba(255, 255, 255, 1);
    }
    100% {
      fill: rgba(35, 35, 35, 1);
    }
  }
}
</style>
